import React from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import styles from './FormItem.module.scss';

const getValidateStatusAndHelp = ({ errors }) => {
  const hasError = Boolean(errors?.length);

  return {
    validateStatus: hasError ? 'error' : undefined,
    help: hasError ? errors.join(', ') : undefined,
  };
};

const FormItem = ({ className, errors, colon = false, ...props }) => (
  <Form.Item
    {...props}
    {...getValidateStatusAndHelp({ errors })}
    colon={colon}
    className={cn(styles.root, className)}
  />
);

export default FormItem;
